import axios from "axios"
import { store } from "../store"
import { SET_SKILLS_EXECEPTIONS, SET_SKILLS_OPENING_HOURS } from "../store/periods/actions"
import { deepEqual } from "../tools/deepEqual"
import { setAsyncInterval } from "../tools/setAsyncInterval"

const INTERVAL = 1 * 60 * 1000

setAsyncInterval(async ({ setOnceNextTime }) => {
  if (axios.defaults.headers.common.Authorization) {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/skills/exceptions`, {})
    const timezoneOffset = new Date().getTimezoneOffset()

    const exceptions = response.data.reduce((acc, { skill_id, start_utc, end_utc }) => {
      const startAt = new Date(new Date(start_utc).getTime() - timezoneOffset * 60 * 1000)
      const endAt = new Date(new Date(end_utc).getTime() - timezoneOffset * 60 * 1000)
      const range = [ startAt, endAt ]
      const data = acc[skill_id] ?? []

      return { ...acc, [skill_id]: data.concat([range]) }
    }, {})

    const state = store.getState()

    if (!deepEqual(exceptions, state.Periods.exceptions, true))

      store.dispatch({ type: SET_SKILLS_EXECEPTIONS, exceptions })
  } else setOnceNextTime(1 * 1000)
}, INTERVAL)

setAsyncInterval(async ({ setOnceNextTime }) => {
  if (axios.defaults.headers.common.Authorization) {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/skills/opening-hours`, {})
  
    const openingHours = response.data

    const state = store.getState()

    if (!deepEqual(openingHours, state.Periods.openingHours, true))

      store.dispatch({ type: SET_SKILLS_OPENING_HOURS, openingHours })
  } else setOnceNextTime(1 * 1000)
}, INTERVAL)
